module.exports = __webpack_public_path__ + "static/media/team-marker.1d09a291.svg";